import PropTypes from 'prop-types';

import { forwardRef, useState } from 'react';
import { InputAdornment } from '@mui/material';
import MDInput from 'components/MDInput';

/**
 * Based on https://codesandbox.io/p/sandbox/material-ui-textfield-label-shrink-03-forked-kswu2e?file=%2Fdemo.tsx%3A50%2C17
 */
const InputWithStartAdornment = forwardRef(
  (
    {
      adornmentIcon,
      label,
      error = false,
      errorMsg,
      success = false,
      disabled = false,
      endAdornment,
      ...others
    },
    ref
  ) => {
    const [shrink, setShrink] = useState(false);

    return (
      <MDInput
        ref={ref}
        margin="normal"
        sx={(theme) => ({
          '& .MuiOutlinedInput-root': {
            paddingLeft: 0
          },
          '& .Mui-focused .MuiInputAdornment-root': {
            color: theme.palette.primary.main
          },
          '& .MuiOutlinedInput-notchedOutline': {
            px: 6
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'white!important'
          }
        })}
        label={label}
        error={error}
        success={success}
        disabled={disabled}
        helperText={errorMsg}
        InputLabelProps={{ sx: { ml: 5 }, shrink }}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{
                backgroundColor: (theme) => theme.palette.primary.main,
                padding: '22px 10px',
                borderTopLeftRadius: (theme) => `${theme.borders.borderRadius.md}`,
                borderBottomLeftRadius: (theme) => `${theme.borders.borderRadius.md}`
              }}
            >
              {adornmentIcon}
            </InputAdornment>
          ),
          endAdornment,
          onFocus: () => setShrink(true),
          onBlur: (e) => setShrink(!!e.target.value)
        }}
        {...others}
      />
    );
  }
);

// Typechecking props for the MDInput
InputWithStartAdornment.propTypes = {
  adornmentIcon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  formRegister: PropTypes.object,
  endAdornment: PropTypes.object
};

export default InputWithStartAdornment;
